<template>
  <div>
    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>
<!--    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>-->
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th>名稱</th>
        <th>說明</th>
        <th>價格</th>
<!--        <th>庫存數量</th>-->
<!--        <th>已銷售數量</th>-->
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td width="300px">
          <input type="text" class="form-control"  placeholder="" v-model="item.name">
        </td>
        <td>
          <MyCkEditor v-model="item.desc" height="300px" width="500px"></MyCkEditor>
        </td>
        <td width="120px">
          <input type="number" class="form-control"  placeholder="" v-model="item.price">
        </td>

<!--        <td width="120px">-->
<!--          <input type="number" class="form-control"  placeholder="" v-model="item.quantity">-->
<!--        </td>-->


<!--        <td width="120px">-->
<!--          <input type="number" class="form-control"  placeholder="" v-model="item.quantity_saled">-->
<!--        </td>-->


      </tr>

      </tbody>
    </table>

  </div>
</template>

<script>
/**

 **/


import Vue from "vue";
import apiFireGodsec from "@/views/fireGods/js/apiFireGodsec";
import MyCkEditor from "@/taylorCommon/component/MyCkEditor.vue";

export default {
  components: {MyCkEditor},
  //name: "setting",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{

      },
      groupIsShowEditor:[]
    };
  },
  methods: {
    loadData() {
      // let data=apiAdmin.api_getContent(this.queryType);
      // debugger // eslint-disable-line
      // console.log(data);
      let that=this;

      apiFireGodsec.api_Admin_Product_Query().then((data)=>{
        let dataApi=data.data.data;
        // let dataApi=apiAdmin.init(data.data.data);
        that.datas=dataApi;
      })
    },
    submit(){
      debugger // eslint-disable-line
      apiFireGodsec.api_Admin_Product_Save(this.datas).then((data)=>{
        console.log(data);
        alert('儲存成功')
      })
    },
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    // showEditor(item){
    //   if (this.groupIsShowEditor[item.group_name]===undefined || this.groupIsShowEditor[item.group_name]===item.id){
    //     this.groupIsShowEditor[item.group_name]=item.id;
    //     return true;
    //   }else{
    //     return false;
    //   }
    // },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
